"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonthlySavingsResponseMapper = void 0;
var MonthlySavingsResponseMapper = /** @class */ (function () {
    function MonthlySavingsResponseMapper(data) {
        this.localData = data;
    }
    MonthlySavingsResponseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return MonthlySavingsResponseMapper;
}());
exports.MonthlySavingsResponseMapper = MonthlySavingsResponseMapper;
//# sourceMappingURL=MonthlySavingsResponseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/models/mappers/MonthlySavingsResponseMapper.js
// module id = 1451
// module chunks = 8